export const Tabs = {
  minHeight: 54,
}
